import arrowLeft from '../../assets/icons/arrow-left.svg';
import arrowRight from '../../assets/icons/arrow-right.svg';


export default function createPdfViewer(doc, id, location) {
    $(`#${location}`).append(getPdfBoilerplate(id, doc.name));
    init(doc.url, id);
}

const getPdfBoilerplate = (id, name) => {
    return `
        <div class="${id}-pdfViewer">
            <div>
                <h1 class="wide-title text-center">
                    ${name}
                </h1>
            </div>
            <div id="${id}-canvas-container" class="canvas-container">
                <canvas class="pdf-canvas" id="${id}-pdf-render"></canvas>
            </div>
            <div id="${id}-pdf-navigation" class="pdf-navigation row no-gutters">
                <button id="${id}-prev-page" class="c-btn col-4">
                <img src="${arrowLeft}" alt="Left">
                </button>
                <div class="c-con col-4">
                    <span id="${id}-page-num"></span> / <span id="${id}-page-count"></span>
                </div>
                <button id="${id}-next-page" class="c-btn col-4">
                    <img src="${arrowRight}" alt="Right">
                </button>
            </div>
        </div>
    `
}

const init = (url, id) => {
    let pdfDoc = null,
        pageNum = 1,
        pageIsRendering = false,
        pageNumIsPending = null;

    const scale = 1.5,
        canvas = document.querySelector(`#${id}-pdf-render`),
        ctx = canvas.getContext('2d');

    const containerWidth = document.getElementById(`${id}-canvas-container`).clientWidth;
    canvas.width = containerWidth;

    //get Document
    pdfjsLib.getDocument(url).promise.then(data => {
        pdfDoc = data;
        document.querySelector(`#${id}-page-count`).textContent = pdfDoc.numPages;
        render(pageNum);
    }).catch(err => {
        document.querySelector(`#${id}-page-navigation`).style.display = 'none';
    })

    //Render the page
    const render = num => {
        pageIsRendering = true;
        // get page
        pdfDoc.getPage(num).then(page => {
            const viewport = page.getViewport({
                scale
            });
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: ctx,
                viewport
            }
            page.render(renderContext).promise.then(() => {
                pageIsRendering = false;
                if (pageNumIsPending !== null) {
                    render(pageNumIsPending);
                    pageNumIsPending = null;
                }
            });

            // output current page 
            document.querySelector(`#${id}-page-num`).textContent = num;
        })
    }



    //check for pages rendering 
    const requestRender = num => {
        pageIsRendering ? pageNumIsPending = num : render(num);
    }

    //show prev page
    const showPrevPage = () => {
        if (pageNum <= 1) return;
        pageNum--;
        requestRender(pageNum);
    }

    //show next page
    const showNextPage = () => {
        if (pageNum >= pdfDoc.numPages) return;
        pageNum++;
        requestRender(pageNum);
    }

    //events
    document.querySelector(`#${id}-prev-page`).addEventListener('click', showPrevPage);
    document.querySelector(`#${id}-next-page`).addEventListener('click', showNextPage);
}